/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type ListAgentGraphsPathParams = NonNullable<operations['listAgentGraphs']['parameters']['path']>;

export type ListAgentGraphsQueryParams = NonNullable<operations['listAgentGraphs']['parameters']['query']>;

export interface Input extends ListAgentGraphsPathParams {
  apiVersion?: string;
  query?: ListAgentGraphsQueryParams;
  header: NonNullable<operations['listAgentGraphs']['parameters']['header']>;
}

export async function listAgentGraphs(
  { apiVersion, query, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/projects/{projectKey}/agent-graphs', {
    params: { path, query, header },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
